import React, { Component } from 'react'
import { StyleModal } from './style'
import { Button } from '../../../components'
import { MODAL_CONFIRM } from '../../../helpers'
export class ModalConfirm extends Component {
  render() {
    const {
      onClickCancel,
      validate,
      onClickAction,
      description,
      text,
      language,
      colorTheme,
      contentText,
      header,
      nameButtonCancel,
      nameButtonOk,
    } = this.props

    return (
      <StyleModal colorTheme={colorTheme}>
        <div className='div-Modal' />
        <div className='content-Modal'>
          <div className='sub-content'>
            <div className='head-modal'>
             {header || MODAL_CONFIRM.HEAD[language]}
            </div>
            {description && <div className='description'>
              {description}
              <div>
                {MODAL_CONFIRM.SURE[language]}
              </div>
            </div>}
            {contentText && <div className='text-content'>
              {contentText}
            </div>}
            {text && <div className='text-data'>
              {text}
            </div>}

            {validate &&
              <div className='text-error'>
                {validate.description}
              </div>
            }
            <div className='tabel btn-modal'>
              <div className='table-row'>
                <div className='table-cell tabel-left'>
                  <Button
                    name={nameButtonOk || MODAL_CONFIRM.OK[language]}
                    onClick={onClickAction}
                    className={`modal-btn-confirm`}
                  />
                </div>

                <div className='table-cell tabel-right'>
                  <Button
                    name={nameButtonCancel || MODAL_CONFIRM.KEEP[language]}
                    onClick={onClickCancel}
                    className='modal-btn-keep'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleModal>
    )
  }
}
